import { ROOT_URL } from "../../constants/api";
import { getAccessToken } from "../../helper/localStorage";
import axiosClient from "../api-caller";

export const authApis = {
  login: async (data) => {
    const url = ROOT_URL + "admin/login";
    return await axiosClient.post(url, data);
  },
  deleteImg: async (data) => {
    const url = ROOT_URL + "admin/delete-img";
    return await axiosClient.post(url, data);
  },
  newFolder: async (data) => {
    const url = ROOT_URL + "admin/new-folder";
    return await axiosClient.post(url, data);
  },
  logout: async () => {
    const url = ROOT_URL + "admin/logout";
    return axiosClient.get();
  },
  register: async (data) => {
    const url = ROOT_URL + "admin/register";
    return await axiosClient.post(url, data);
  },
  addSetting: async (data) => {
    const url = ROOT_URL + "admin/update-setting";
    return await axiosClient.post(url, data);
  },
  getSetting: async () => {
    const url = ROOT_URL + "admin/setting";
    return axiosClient.get(url);
  },
  news: async (data) => {
    const url = ROOT_URL + "admin/news";
    return await axiosClient.post(url, data);
  },
  deleteNews: async (id) => {
    const url = ROOT_URL + "admin/news/" + id;
    return await axiosClient.delete(url);
  },
  deleteBrand: async (id) => {
    const url = ROOT_URL + "admin/brand/" + id;
    return await axiosClient.delete(url);
  },
  deleteAddress: async (id) => {
    const url = ROOT_URL + "admin/address/" + id;
    return await axiosClient.delete(url);
  },
  deleteMenu: async (id) => {
    const url = ROOT_URL + "admin/menu/" + id;
    return await axiosClient.delete(url);
  },

  deleteBanner: async (id) => {
    const url = ROOT_URL + "admin/banner/" + id;
    return await axiosClient.delete(url);
  },
  deleteContact: async (id) => {
    const url = ROOT_URL + "admin/contact/" + id;
    return await axiosClient.delete(url);
  },
  getNews: async (urlParams) => {
    const url = ROOT_URL + "admin/news?" + urlParams;
    return await axiosClient.get(url);
  },
  getLang: async (urlParams) => {
    const url = ROOT_URL + "admin/lang?" + urlParams;
    return await axiosClient.get(url);
  },

  getMedia: async (urlParams) => {
    const url = ROOT_URL + "admin/media-scan?" + urlParams;
    return await axiosClient.get(url);
  },
  importlang: async (data) => {
    const url = ROOT_URL + "admin/importlang";
    return await axiosClient.post(url,data);
  },
  uploadFile: async (data) => {
    const url = ROOT_URL + "admin/upload-file";
    return await axiosClient.post(url,data);
  },
  getDetailNews: async (id) => {
    const url = ROOT_URL + "admin/get-detail-news/" + id;
    return await axiosClient.get(url);
  },
  getDetailContact: async (id) => {
    const url = ROOT_URL + "admin/get-detail-contact/" + id;
    return await axiosClient.get(url);
  },
  getDetailUser: async (id) => {
    const url = ROOT_URL + "admin/get-detail-user";
    return await axiosClient.post(url, {id: id});
  },
  getAddressBanner: async (id) => {
    const url = ROOT_URL + "admin/get-detail-address/" + id;
    return await axiosClient.get(url);
  },

  getStaticPage: async (id) => {
    const url = ROOT_URL + "admin/get-static-page/" + id;
    return await axiosClient.get(url);
  },
  getContactList: async (urlParams) => {
    const url = ROOT_URL + "admin/contact-list?" + urlParams;
    return await axiosClient.get(url);
  },
  getMenuList: async (urlParams) => {
    const url = ROOT_URL + "admin/menu-list?" + urlParams;
    return await axiosClient.get(url);
  },
  getBrandList: async (urlParams) => {
    const url = ROOT_URL + "admin/brand-list?" + urlParams;
    return await axiosClient.get(url);
  },
  getBannerList: async (urlParams) => {
    const url = ROOT_URL + "admin/banner-list?" + urlParams;
    return await axiosClient.get(url);
  },
  getAddressList: async (urlParams) => {
    const url = ROOT_URL + "admin/address-list?" + urlParams;
    return await axiosClient.get(url);
  },
  getApplyList: async (urlParams) => {
    const url = ROOT_URL + "admin/apply-list?" + urlParams;
    return await axiosClient.get(url);
  },
   getUserList: async (urlParams) => {
    const url = ROOT_URL + "admin/user-list?" + urlParams;
    return await axiosClient.get(url);
  },
  banner: async (data) => {
    const url = ROOT_URL + "admin/banner";
    return await axiosClient.post(url, data);
  },
  updateUser: async (data) => {
    const url = ROOT_URL + "admin/update-user";
    return await axiosClient.post(url, data);
  },

  address: async (data) => {
    const url = ROOT_URL + "admin/address";
    return await axiosClient.post(url, data);
  },
  updateLang: async (data) => {
    const url = ROOT_URL + "admin/lang";
    return await axiosClient.post(url, data);
  },
  getDetailBanner: async (id) => {
    const url = ROOT_URL + "admin/get-detail-banner/" + id;
    return await axiosClient.get(url);
  },
  brand: async (data) => {
    const url = ROOT_URL + "admin/brand";
    return await axiosClient.post(url, data);
  },
  getDetailBrand: async (id) => {
    const url = ROOT_URL + "admin/get-detail-brand/" + id;
    return await axiosClient.get(url);
  },
  addStaticPage: async (data) => {
    const url = ROOT_URL + "admin/add-static-page";
    return await axiosClient.post(url, data);
  },
  getCategory: async () => {
    const url = ROOT_URL + "admin/category";
    return await axiosClient.get(url);
  },
  teacherList: async (urlParams) => {
    const url = ROOT_URL + "admin/teacher-list?" + urlParams;
    return await axiosClient.get(url);
  },
  teacher: async (data) => {
    const url = ROOT_URL + "admin/teacher";
    return await axiosClient.post(url, data);
  },
  teacherById: async (id) => {
    const url = ROOT_URL + "admin/teacher/" + id;
    return await axiosClient.get(url);
  },
  getHoiDap: async (urlParams) => {
    const url = ROOT_URL + "admin/hoi-dap?" + urlParams;
    return await axiosClient.get(url);
  },
  getDetailHoiDap: async (id) => {
    const url = ROOT_URL + "admin/get-detail-hoi-dap/" + id;
    return await axiosClient.get(url);
  },
  addHoiDap: async (data) => {
    const url = ROOT_URL + "admin/add-hoi-dap";
    return await axiosClient.post(url, data);
  },
  deleteHoiDap: async (id) => {
    const url = ROOT_URL + "admin/delete-hoi-dap/" + id;
    return await axiosClient.delete(url);
  },
  getEvent: async (urlParams) => {
    const url = ROOT_URL + "admin/event?" + urlParams;
    return await axiosClient.get(url);
  },
  getDetailEvent: async (id) => {
    const url = ROOT_URL + "admin/get-detail-event/" + id;
    return await axiosClient.get(url);
  },
  addEvent: async (data) => {
    const url = ROOT_URL + "admin/add-event";
    return await axiosClient.post(url, data);
  },
  deleteEvent: async (id) => {
    const url = ROOT_URL + "admin/delete-event/" + id;
    return await axiosClient.delete(url);
  },
  deleteApply: async (id) => {
    const url = ROOT_URL + "admin/delete-apply/" + id;
    return await axiosClient.delete(url);
  },
  getDetailApply: async (id) => {
    const url = ROOT_URL + "admin/get-detail-apply/" + id;
    return await axiosClient.get(url);
  },
  downloadCV: async (id, options = {}) => {
    const url = ROOT_URL + "admin/download-cv/" + id;
    return await axiosClient.get(url, { 
      responseType: 'blob',
      ...options 
    });
  },
  updateApplyStatus: async (id, data) => {
    const url = ROOT_URL + "admin/update-apply-status/" + id;
    return await axiosClient.post(url, data);
  },
};
